import { Component, OnInit } from '@angular/core';
import { CategoriaTrabajoService, CongresosService, TrabajosService } from '../../services/services.index';
import { CategoriaTrabajo } from '../../models/categoriaTrabajo.model';
import { ActivatedRoute } from '@angular/router';
import { Congreso } from '../../models/congreso.model';

import * as htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-descarga-trabajos',
  templateUrl: './descarga-trabajos.component.html',
  styles: []
})
export class DescargaTrabajosComponent implements OnInit {

  categoriasTrabajo: CategoriaTrabajo[] = [];
  congreso: Congreso;
  loading: boolean = true;

  constructor(public _categoriaTrabajoService: CategoriaTrabajoService,
              private activatedRoute: ActivatedRoute,
              public _congresosService: CongresosService,
              public _trabajosService: TrabajosService) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
        this.congreso = data.congreso;
        this._categoriaTrabajoService.getAllCategoriasTrabajo().subscribe(resp => {
          for (let categoria of resp.categoriasTrabajo) {
            if (!categoria.parent) {
              this.categoriasTrabajo.push(categoria);
            }
          }
          console.log(this.categoriasTrabajo);
          this.loading = false;
        });
      });
    });
  }

  descargarTrabajos() {

    this._trabajosService.getTrabajoPorCongresoTodos(this.congreso._id).subscribe((dataTrabajos: any) => {
      console.log(dataTrabajos);
      this.generarWord(dataTrabajos, 'Todos los Trabajos');
    });

  }

  descargarTrabajosPorCateg(categoria: any) {
    this._trabajosService.getTrabajoPorCongresoCategTodos(this.congreso._id, categoria._id).subscribe(dataTrabajos => {
      console.log(dataTrabajos);
      this.generarWord(dataTrabajos, categoria.nombre_es);
    });
  }

  generarWord(dataTrabajos: any[], tituloArchivo: string) {
    let content: string = '';
    let count: number = 0;
      for (let trabajo of dataTrabajos) {
        let countAutores: number = 0;
        // if (tituloArchivo === 'Todos los Trabajos' && count === 0) {
        //   content += '<h1>' + trabajo.categoriasTrabajo[trabajo.categoriasTrabajo.length - 1].nombre_es.toUpperCase() + '</h1>';
        // }
        // if (tituloArchivo === 'Todos los Trabajos' && count !== 0 &&
        // // el length hay que sacarlo de la dataTrabajos y no de trabajos
        // dataTrabajos[count].categoriasTrabajo[dataTrabajos[count].categoriasTrabajo.length - 1]._id
        // !== dataTrabajos[count - 1].categoriasTrabajo[dataTrabajos[count].categoriasTrabajo.length - 1]._id) {
        //   content += '<br><br><br>';
        //   content += '<h1>' + trabajo.categoriasTrabajo[trabajo.categoriasTrabajo.length - 1].nombre_es.toUpperCase() + '</h1>';
        // }

        if (count === 0) {
          content += '<h1>' + trabajo.categoriaTrabajoPrincipal.nombre_es.toUpperCase() + '</h1>';
        }
        if (count !== 0 && dataTrabajos[count].categoriaTrabajoPrincipal._id !== dataTrabajos[count - 1].categoriaTrabajoPrincipal._id) {
          content += '<h1>' + trabajo.categoriaTrabajoPrincipal.nombre_es.toUpperCase() + '</h1>';
        }
        count++;

        content += '<h2>' + trabajo.titulo.toUpperCase() + '</h2>';
        content += '<p>';
        for (let autor of trabajo.autores) {
          content += '<span>';
          countAutores ++;
          if (countAutores === 1) {
            // Primer Autor
            content += autor.apellido + ' ' + this.inicialesNombres(autor.nombres);
          } else {
            // Los demas autores
            content += this.inicialesNombres(autor.nombres) + ' ' + autor.apellido;
          }
          // Indices de lugares
          content += '<sup>' +  this.superindiceLugares(autor.lugaresTrabajo) + '</sup>';
          if (countAutores !== trabajo.autores.length) {
            // Agrego ,
            content += ', ';
          } else {
            // Como es el ultimo agrego .
            content += '. ';
          }
          content += '</span>';
        }

        // Lugares de Trabajo
        let cantLugar: number = 0;
        for (let lugar of trabajo.lugaresTrabajo) {
          cantLugar ++;
          content += '<sup>' + lugar.id + '</sup> ' + lugar.nombre;
          if (cantLugar !== trabajo.lugaresTrabajo.length) {
            // Agrego ,
            content += '; ';
          } else {
            // Como es el ultimo agrego .
            content += '. ';
          }
        }
        content += '</p>';
        content += '<p>' + trabajo.contactoAutor + '</p>';
        content += '<p>' + trabajo.textoTrabajo + '</p>';
        content += '<br><hr><br><br>';

      }

      let htmlDocument = '<!DOCTYPE html><html><head><meta charset="utf-8"><title></title>';
      htmlDocument  = htmlDocument + '</head><body>' + content + '</body></html>';
      const converted = htmlDocx.asBlob(htmlDocument);
      saveAs(converted, tituloArchivo + '.docx');
  }

  inicialesNombres(nombres: string) {
    let iniciales: string = '';
    let arrayNombres: any[] = nombres.split(' ');
    for (let nombre of arrayNombres) {
      iniciales = iniciales + nombre.substr(0, 1) + '.';
    }
    return iniciales.toUpperCase();
  }

  superindiceLugares(lugaresTrabajo: any) {
    let superindice: string = '';
    for (let lugar of lugaresTrabajo) {
      if (superindice === '') {
        superindice = superindice + lugar;
      } else {
        superindice = superindice + ',' + lugar;
      }
    }
    return superindice;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/descarga-trabajos/descarga-trabajos.component.ts